import { FCX, Tooltip } from "@datassential/platform-ui-lib";
import { flip, shift, offset } from '@floating-ui/dom';
import { useConsumerGroupsContext } from "@pages/Profile/components/ConsumerGroups/ConsumerGroups";
import { useSegmentsOnSitesWithChildren } from "@core/CommonDataContext";
import {
    ConsumerGroupsTableItem,
    useConsumerGroupsTableMetrics
} from "./ConsumerGroupsTableConfig";
import { useMemo } from "react";
import Popup from "@components/Popup";
import Common from "@pages/Profile/components/ConsumerGroups/Common";

const Segments: FCX = (props) => {
    const getMetricsData = useConsumerGroupsTableMetrics();
    const { data } = useConsumerGroupsContext();

    const options = useSegmentsOnSitesWithChildren();

    const segments = useMemo(
        () => {
            return [...(data.segments ?? []), ...(data.onSites ?? [])];
        },
        [data.segments, data.onSites]
    );

    const itemsData = useMemo(
        (): ConsumerGroupsTableItem[] => {
            return segments.map((item) => {
                const itemData = options.find((i) => i.id === item.id);

                return {
                    id: item.id,
                    name: itemData?.name ?? '',
                    nameTooltipId: `consumer-group-segments-table-item-${itemData?.id}-name`,
                    baseSize: item.base ?? 0,
                    metrics: getMetricsData(item.metrics ?? []),
                };
            });
        },
        [options, segments, getMetricsData]
    );

    return (
        <Common {...props} data={itemsData}>
            <Popup>
                {options.map(option => {
                    if (option.items.length === 0) return null;

                    return (
                        <Tooltip
                            key={option.id}
                            place="right"
                            variant="light"
                            clickable
                            id={`consumer-group-segments-table-item-${option.id}-name`}
                            middlewares={[flip(), shift({ padding: 5 }), offset(10)]}
                            delayShow={300}
                        >
                            <div className="ProfileConsumerGroups__table-sub-items-tooltip">
                                {option.items.map((item) => (
                                    <div
                                        key={item.id}
                                        className="ConsumerGroups__table-sub-item"
                                    >
                                        {item.name}
                                    </div>
                                ))}
                            </div>
                        </Tooltip>
                    )
                })}
            </Popup>
        </Common>
    );
}

export default Segments;